import * as React from "react";

import Advertisement from "../../containers/advertisement";
import ResponsiveImage from "../shared/responsiveImage";
import styles from "./style.scss";

const ADVERT_TYPE = "square";
const WIDTH = "300";
const HEIGHT = "250";

const SquareAdvertisement = ({ uid, competitionId }) => (
  <Advertisement type={ADVERT_TYPE} uid={uid} competitionId={competitionId}>
    {(advertisement, handleClick) => (
      <div className={styles.advert}>
        <ResponsiveImage
          width={WIDTH}
          height={HEIGHT}
          src={advertisement.images.src}
          srcset={advertisement.images.srcset}
          alt={advertisement.images.alt}
          title={advertisement.name}
          className={styles.advertImg}
          lazyload
          onClick={handleClick}
          data-advert={advertisement.key}
          data-uid={uid}
        />
      </div>
    )}
  </Advertisement>
);

export default SquareAdvertisement;
